import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import { fade } from 'styles/animations'

export const Wrapper = styled.div`
  ${() => css`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 80px;

    ${media.lessThan('medium')`
      margin-top: 40px;
    `}
  `}
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 846px;
`

export const TabWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    justify-content: center;

    div {
      ${({ active }) => css`
        &:nth-child(1) > span {
          &::after {
            background-color: ${theme.colors.primary.main};
            content: '';
            position: absolute;
            width: 0;
            height: 4px;
            top: 48px;
            left: 40.2%;
            transform: translateX(-50%);
            transition: width 0.25s ease;
          }

          &:hover,
          &:focus {
            &::after {
              width: 167px;
            }
          }
        }

        &:nth-child(2) > span {
          &::after {
            background-color: ${theme.colors.primary.main};
            content: '';
            position: absolute;
            width: 0;
            height: 4px;
            top: 48px;
            left: 59.8%;
            transform: translateX(-50%);
            transition: width 0.25s ease;
          }

          &:hover,
          &:focus {
            &::after {
              width: 166px;
            }
          }
        }
      `}
    }

    ${media.lessThan('medium')`
      width: 100%;
      padding: 0 24px;

      div {
        &:nth-child(1) > span {
          &:hover,
          &:focus {
            &::after {
              width: 0;
            }
          }
        }

        &:nth-child(2) > span {
          &:hover,
          &:focus {
            &::after {
              width: 0;
            }
          }
        }
      }
    `}
  `}
`

export const TabOption = styled.div`
  ${({ theme, active }) => css`
    display: flex;
    justify-content: center;
    width: 166px;
    border-bottom: ${`4px solid ${
      active
        ? theme.colors.primary.main
        : theme.colors.grayscale.tab.borderDisabled
    }`};
    cursor: pointer;
    transition: all 0.3s ease 0s;

    &:hover {
      border-bottom: ${`4px solid ${theme.colors.primary.main}`};
    }

    ${media.lessThan('medium')`
      min-width: 130px;
      max-width: 156px;
      width: 50%;
    `}
  `}
`

export const OptionTitle = styled.span`
  ${({ theme, active }) => css`
    font-family: ${theme.font.familyTertiary};
    color: ${active
      ? `${theme.colors.primary.main}`
      : `${theme.colors.grayscale.tab.titleDisabled}`};
    font-size: ${theme.font.sizes.large};
    font-weight: ${theme.font.black};
    line-height: 48px;
    text-align: center;
    padding: 0 32px;
    cursor: pointer;
    transition: all 0.3s ease 0s;

    &:hover {
      color: ${theme.colors.primary.main};
    }

    ${media.lessThan('medium')`
      font-size: 24px;
      font-weight: 700;
      line-height: 32px;
      letter-spacing: 1px;
      text-align: center;
      padding: 0 16px;
    `}
  `}
`

export const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  border: 1px solid #c4c4c4;

  ${fade(0.5)}

  &:not(:first-child) {
    margin-top: 16px;
  }
`

export const TabContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 48px;
  width: 100%;

  ${fade(0.5)}

  ${media.lessThan('medium')`
    width: 100%;
    padding: 0 24px;
    margin-top: 40px;
  `}
`

export const Time = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.grayscale.light.paragraph};
    padding: 16px 64px;
    background: #f6f6f6;
    border-right: 1px solid #c4c4c4;
    font-family: ${theme.font.primary};
    font-size: ${theme.font.sizes.large};
    font-weight: ${theme.font.bold};
    line-height: 29px;
    letter-spacing: 0em;
    text-align: left;

    ${media.lessThan('medium')`
      font-size: ${theme.font.sizes.medium};
      padding: 16px 21px;
    `}
  `}
`

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.grayscale.light.info};
    font-family: ${theme.font.primary};
    font-size: ${theme.font.sizes.medium};
    font-weight: ${theme.font.black};
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    align-self: center;
    padding: 16px;

    ${media.lessThan('medium')`
      font-size: ${theme.font.sizes.medium};
      padding: 16px 8px;
      width: 40%;
    `}
  `}
`
